import Vue from 'vue'
import App from '../../jscommon/umychart.vue.components/stockinfo.vue'

new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/pages/test/index.js